export default "__VITE_ASSET__DeVWUELt__"